/* eslint-disable import-x/no-default-export */
import Chance from 'chance';
const chance = new Chance();

import getRecommendationsResponse from './GetRecommendationsResponse';

const recommendedJob = () => {
  const jobs =
    getRecommendationsResponse?.viewer?.recommendations?.recommendedJobs?.jobs;

  return chance.pickone(jobs ?? []);
};

chance.mixin({
  recommendedJob,
});

// @ts-ignore - recommendedJob is mixin on chance
export default () => chance.recommendedJob();
